const accounting = require('accounting');

const OFFER_PRICE = 'input#offer_price';
const OFFER_SHIPPING_PRICE = 'input#offer_shipping_price';
const OFFER_QUANTITY = '[data-quantity]';
const OFFER_TOTAL = 'input#offer_total';
const DEFAULT_QUANTITY = 1;
const DECIMAL = I18n.t('number.currency.format.separator');
const THOUSAND  = I18n.t('number.currency.format.delimiter');
const MONEY_FORMAT = {
  symbol: '',
  decimal: DECIMAL,
  thousand: THOUSAND,
  precision: 2,
};

class ReverbOffers {
  static selectDefaultOfferTab() {
    const buyerCount = $('#buying [data-offer-view-offer-container] > *').length;
    const sellerCount = $('#selling [data-offer-view-offer-container] > *').length;
    if (sellerCount > buyerCount) {
      window.Tabs.switchTab('#selling');
    }
  }

  static formatMoneyFields(scope) {
    const price = scope.find(OFFER_PRICE);
    const shipping = scope.find(OFFER_SHIPPING_PRICE);
    const total = scope.find(OFFER_TOTAL);
    const unformattedPrice = accounting.unformat(price.val(), DECIMAL);
    const unformattedShipping = accounting.unformat(shipping.val(), DECIMAL);
    const unformattedTotal = (unformattedPrice * ReverbOffers.quantityValue(scope)) + unformattedShipping;

    if (price.val()) {
      price.val(accounting.formatMoney(unformattedPrice, MONEY_FORMAT));
    }
    shipping.val(accounting.formatMoney(unformattedShipping, MONEY_FORMAT));
    total.val(accounting.formatMoney(unformattedTotal, MONEY_FORMAT));
  }

  static quantityValue(scope) {
    const offerQuantity = scope.find(OFFER_QUANTITY);

    // the seller side has a select tag with a value
    if (offerQuantity.val()) {
      return offerQuantity.val();
    }

    // on the buyer side there is a div with a data attribute 'quantity'
    if (offerQuantity.data('quantity')) {
      return offerQuantity.data('quantity');
    }

    // if there is no quantity specified, default to 1
    return DEFAULT_QUANTITY;
  }

  static calculateCounterOfferTotal(scope) {
    const price = scope.find(OFFER_PRICE);
    const shipping = scope.find(OFFER_SHIPPING_PRICE);
    const total = scope.find(OFFER_TOTAL);
    const unformattedPrice = accounting.unformat(price.val(), DECIMAL);
    const unformattedShipping = accounting.unformat(shipping.val(), DECIMAL);
    const unformattedTotal = (unformattedPrice * ReverbOffers.quantityValue(scope)) + unformattedShipping;

    total.val(accounting.formatMoney(unformattedTotal, MONEY_FORMAT));
  }

  static calculateTotalOnChange() {
    const fields = $([OFFER_QUANTITY, OFFER_PRICE, OFFER_SHIPPING_PRICE].join());
    fields.change((field) => {
      const context = $(field.target).parents('form');
      ReverbOffers.formatMoneyFields(context);
      ReverbOffers.calculateCounterOfferTotal(context);
    });
  }
}

function init() {
  ReverbOffers.selectDefaultOfferTab();
  $.each($('form.edit_offer'), (i, v) => {
    ReverbOffers.formatMoneyFields($(v));
    ReverbOffers.calculateCounterOfferTotal($(v));
  });
  ReverbOffers.calculateTotalOnChange();
}

module.exports = {
  init,
};



// WEBPACK FOOTER //
// ./javascripts/components/legacy/reverb_offers.js